import { Skeleton as TaichiSkeleton } from '@gympass/tai-chi/skeleton';
import styled from '@mui/material/styles/styled';

export const LogoWrapper = styled('div')(() => ({
  justifySelf: 'start',
}));

export const Header = styled('header')(({ theme }) => ({
  position: 'sticky',
  top: 0,
  zIndex: 1,
  display: 'grid',
  alignContent: 'center',
  width: '100%',
  overflowX: 'auto',
  backgroundColor: theme.palette.background.default,
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: theme.spacing(2),
  paddingInline: theme.spacing(4),
  paddingTop: theme.spacing(2),

  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '2fr 3fr',
    paddingInline: theme.spacing(6),
  },
}));

export const HeaderContent = styled('div')(({ theme }) => ({
  display: 'grid',
  alignItems: 'center',
  gridTemplate: 'auto / repeat(3, max-content)',
  justifyContent: 'end',
  gap: theme.spacing(2),

  [theme.breakpoints.up('md')]: {
    gap: theme.spacing(4),
    backgroundColor: theme.palette.background.default,
    width: '100%',
  },
}));

export const Section = styled('section')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  margin: theme.spacing(4, 0),
  gap: theme.spacing(4),
  flex: 1,
  maxWidth: '38rem',
  padding: theme.spacing(5, 8),
  [theme.breakpoints.up('xl')]: {
    padding: 0,
    justifyContent: 'center',
  },
}));

export const CardsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(4),
  marginTop: theme.spacing(4),
  width: '100%',
  backgroundColor: theme.palette.background.default,
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    padding: 0,
  },
  '& .MuiSkeleton-root': {
    height: '10rem',
    maxWidth: '100%',
    alignSelf: 'center',
    [theme.breakpoints.up('md')]: {
      height: '25rem',
    },
  },
}));

export const Skeleton = styled(TaichiSkeleton)({
  maxWidth: '100%',
});

export const Footer = styled('footer')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  zIndex: 1,
  position: 'sticky',
  bottom: 0,
  width: '100%',
  padding: theme.spacing(4, 5),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

export const FooterContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.background.default,
  width: '100%',
}));

export const ActionsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'end',
  gap: theme.spacing(4),
  backgroundColor: theme.palette.background.default,
  borderTop: `1px solid ${theme.palette.primary.light}`,
  padding: theme.spacing(4, 5),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(4, 9),
  },
}));
